import StatBox from "pages/Analytics/elements/StatBox";

import { LoansContext } from "providers/loans";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";

const LoanStatusCount = ({ widget }: { widget: any }) => {
  const { loans } = useContext(LoansContext);
  const {
    user: {
      company: { statuses },
    },
  } = useTenant();

  const [title, setTitle] = useState("");
  const [count, setCount] = useState(0);

  useEffect(() => {
    const status = statuses.find((status: any) => status.id === widget.params.status_id);
    if (status) {
      setTitle(`${status.label} Loans`);
      setCount(loans.filter((loan: any) => loan.status.id === widget.params.status_id).length);
    }
  }, [loans]);

  return <StatBox title={title} stat={count} />;
};

export default LoanStatusCount;
